import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Error404 from '../../Error404';
import { PERMISSION_MY_ACCOUNT_SETTING, ROUTES } from '../../common/constants';
import AccessControl from '../../components/AccessControl';
import './myAccountModule.less';
import MyAccountSettingPage from './pages/MyAccountSettingPage';

const MyAccountSettingWrapper = () => {
  return (
    <div className="my-account-module">
      <Switch>
        <Route
          exact
          path={ROUTES?.MY_ACCOUNT_SETTING}
          render={(props) => (
            <AccessControl
              allowedPermissions={PERMISSION_MY_ACCOUNT_SETTING}
              showNoAccess
            >
              <MyAccountSettingPage {...props} />
            </AccessControl>
          )}
        />
        <Route path="*" exact component={Error404} />
      </Switch>
    </div>
  );
};

export default MyAccountSettingWrapper;
